export const UPDATE_POSTS = 'updatePosts'
export const UPDATE_TAGS = 'updateTags'
